// Vue 3 removed $on/$off/$once from component instances, so a bare `new Vue()` can no longer
// act as an event bus (Phase 2b). `mitt` is the tiny emitter the official Vue 3 migration guide
// itself recommends as the drop-in replacement for this exact pattern.
import mitt from 'mitt'

const EventBus = mitt()

export default EventBus
